module.exports = __webpack_public_path__ + "img/5.e377cf44.jpg";